module.exports = __webpack_public_path__ + "static/media/burger.0e2b392b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/partials/Menu/assets/burger.svg
// module id = 558
// module chunks = 20